export class DateHelper {

  static today() {
    return new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate()
    );
  }

  static yearsAgo(numberOfYears: number, date?: Date): Date {
    if (date) {
      return new Date(
        date.getFullYear() - numberOfYears,
        date.getMonth(),
        date.getDate()
      );
    }

    return new Date(
      new Date().getFullYear() - numberOfYears,
      new Date().getMonth(),
      new Date().getDate()
    );
  }

  static yearsInFuture(numberOfYears: number, date?: Date): Date {
    if (date) {
      return new Date(
        date.getFullYear() + numberOfYears,
        date.getMonth(),
        date.getDate()
      );
    }

    return new Date(
      new Date().getFullYear() + numberOfYears,
      new Date().getMonth(),
      new Date().getDate()
    );
  }

  static monthsAgo(numberOfMonths: number, date?: Date): Date {
    if (date) {
      return new Date(
        date.getFullYear(),
        date.getMonth() - numberOfMonths,
        date.getDate()
      );
    }

    return new Date(
      new Date().getFullYear(),
      new Date().getMonth() - numberOfMonths,
      new Date().getDate()
    );
  }

  static monthsInFuture(numberOfMonths: number, date?: Date): Date {
    if (date) {
      return new Date(
        date.getFullYear(),
        date.getMonth() + numberOfMonths,
        date.getDate()
      );
    }

    return new Date(
      new Date().getFullYear(),
      new Date().getMonth() + numberOfMonths,
      new Date().getDate()
    );
  }

  static daysAgo(numberOfDays: number, date?: Date): Date {
    if (date) {
      return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() - numberOfDays
      );
    }

    return new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - numberOfDays
    );
  }

  static daysInFuture(numberOfDays: number, date?: Date): Date {
    if (date) {
      return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + numberOfDays
      );
    }

    return new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() + numberOfDays
    );
  }

  static differenceInDays(start: Date, end: Date): number {
    // difference in milliseconds
    const differencInTime = end.getTime() - start.getTime();
    // convert to days 1000 * 60 * 60 * 24 = 86,400,000
    return Math.ceil(differencInTime / 86400000);
  }

  static differenceInHours(start: Date, end: Date): number {
    // difference in milliseconds
    const differencInTime = end.getTime() - start.getTime();
    // convert to hours 1000 * 60 * 60 = 3,600,000
    return Math.ceil(differencInTime / 3600000);
  }

  static differenceInMinutes(start: Date, end: Date): number {
    // difference in milliseconds
    const differencInTime = end.getTime() - start.getTime();
    // convert to minutes 1000 * 60 = 60,000
    return Math.ceil(differencInTime / 60000);
  }

  static differenceInSeconds(start: Date, end: Date): number {
    // difference in milliseconds
    const differencInTime = end.getTime() - start.getTime();
    // convert to seconds
    return Math.ceil(differencInTime / 1000);
  }
}
